import { PredefinedFiltersEnum } from '@app/app.enum';
import { IPredefinedFiltersProps } from '@app/models/shared.models';
import Injector from '@app/services';
import { IntlService } from '@app/services/intl.service';
import { ListItemText, MenuItem, TextField } from '@material-ui/core';
import dayjs from 'dayjs';
import React from 'react';

const intlService: IntlService = Injector.get(IntlService);
let initialStartDate: Date;
let initialEndDate: Date;
const PredefinedFilters = (props: IPredefinedFiltersProps) => {
	// ComponentDidMount
	React.useEffect(() => {
		initialStartDate = props.startDate;
		initialEndDate = props.endDate;
	}, []);

	// Filter state for setting the select component value
	const [selectFilter, setSelectFilter] = React.useState(PredefinedFiltersEnum.Custom);

	const applyPredefinedFilters = (filterValue: PredefinedFiltersEnum) => {
		let dateFrom: Date = props.startDate;
		let dateTo: Date = props.endDate;
		switch (filterValue) {
			case PredefinedFiltersEnum.Custom:
				dateFrom = initialStartDate;
				dateTo = initialEndDate;
				break;
			case PredefinedFiltersEnum.Last7Days:
				dateFrom = dayjs(initialEndDate).subtract(7, 'day').toDate();
				dateTo = initialEndDate;
				break;
			case PredefinedFiltersEnum.Last30Days:
				dateFrom = dayjs(initialEndDate).subtract(1, 'month').toDate();
				dateTo = initialEndDate;
				break;
			case PredefinedFiltersEnum.MonthToDate:
				dateFrom = dayjs(props.endDate).startOf('month').toDate();
				break;
			case PredefinedFiltersEnum.QuarterToDate:
				const quarter = quarterCheck(dayjs(props.endDate).month());
				dateFrom = setDateFromForQuarter(quarter);
				break;
			case PredefinedFiltersEnum.YearToDate:
				dateFrom = dayjs(props.endDate).startOf('year').toDate();
			default:
				break;
		}
		setSelectFilter(filterValue);
		props.onDateChange(dateFrom, dateTo, filterValue);
	};

	const quarterCheck = (month: number): number => {
		return Math.floor(month / 3) + 1;
	};

	const setDateFromForQuarter = (quarterNumber: number): Date => {
		const currentDate: Date = dayjs(Date.now()).toDate();
		switch (quarterNumber) {
			case 1:
				return dayjs(currentDate).set('month', 0).set('date', 1).toDate();
			case 2:
				return dayjs(currentDate).set('month', 3).set('date', 1).toDate();
			case 3:
				return dayjs(currentDate).set('month', 6).set('date', 1).toDate();
			case 4:
				return dayjs(currentDate).set('month', 9).set('date', 1).toDate();
			default:
				return currentDate;
		}
	};

	return (
		<TextField
			select={true}
			variant='outlined'
			label={intlService.GetFormattedMessage('app.common-predefined-filters-label')}
			fullWidth={true}
			value={selectFilter}
			inputProps={{ 'data-testid': 'predefinedFilters' }}
			SelectProps={{
				renderValue: (selected: string[]) =>
					intlService.GetFormattedMessage(`app.common-predefined-filters-${selected.toString()}`),
			}}
			onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
				applyPredefinedFilters(e.target.value as PredefinedFiltersEnum);
			}}
		>
			{Object.keys(PredefinedFiltersEnum).map((value: PredefinedFiltersEnum, index: number) => (
				<MenuItem key={index} value={value}>
					<ListItemText primary={intlService.GetFormattedMessage(`app.common-predefined-filters-${value}`)} />
				</MenuItem>
			))}
		</TextField>
	);
};

export default PredefinedFilters;



// WEBPACK FOOTER //
// ./src/components/shared/predefined-filters.component.tsx